import { API_HOST_NAME } from "../constants.js";
import useAuthenticatedResources from "../../../useAuthenticatedResources.js";

const useHetznerServersResources = (teamId, projectId) => {
  const url = `${API_HOST_NAME}/api/v1/cloud/teams/${teamId}/hetzner/projects/${projectId}/servers`;
  return useAuthenticatedResources(url)
}

export default useHetznerServersResources;
